module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.error[0]
    }
  }, [_c('label', [_vm._v("Выберите скидку")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Выберите скидку",
      "filterable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localValue),
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error[0]))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4de0596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/client/fields/Discount.vue
// module id = 694
// module chunks = 0